import React, { useState, useEffect } from "react"; // useEffect burada da tanımlanmalı
import "../styles/Login.css";
import EmailVerificationPopup from "./EmailVerificationPopup";

export default function RegisterPopup({ onClose, openLoginPopup, googleData = {} }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    adi: googleData?.firstName || "",
    soyadi: googleData?.lastName || "",
    email: googleData?.email || "",
    password: "",
    saglayiciId: "0",
    saglayici: googleData?.email ? "google" : "local",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordRules, setPasswordRules] = useState({
    minLength: false,
    hasUpper: false,
    hasLower: false,
    hasNumber: false,
    hasSpecial: false,
  });

  // ✅ ENTER TUŞUYLA KAYIT OL
  useEffect(() => {
    const handleEnter = (e) => {
      if (e.key === "Enter") {
        handleRegister();
      }
    };
    document.addEventListener("keydown", handleEnter);
    return () => document.removeEventListener("keydown", handleEnter);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "adi" || name === "soyadi") {
      setFormData({ ...formData, [name]: value.toLocaleUpperCase("tr-TR") });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (name === "password") {
      setPasswordRules({
        minLength: value.length >= 6,
        hasUpper: /[A-ZÇĞİÖŞÜ]/.test(value),
        hasLower: /[a-zçğıöşü]/.test(value),
        hasNumber: /[0-9]/.test(value),
        hasSpecial: /[^a-zA-ZçğıöşüÇĞİÖŞÜ0-9]/.test(value),
      });
    }
  };

  const handleRegister = async () => {
    setError("");
    setSuccess("");
    setLoading(true);

    if (!formData.adi || !formData.soyadi || !formData.email || !formData.password) {
      setError("⚠️ Tüm alanları doldurun!");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { message: text };
      }

      if (response.ok) {
        if (formData.saglayici === "google") {
          // Google ile kayıt olduysa mail doğrulama göstermeden giriş ekranına geç
          setSuccess("✅ Google ile kayıt başarılı!");
          onClose(); // popup'ı kapat
          openLoginPopup(formData.email); // login popup aç ve maili dolu ver
        } else {
          // Local kayıt ise doğrulama popup aç
          setSuccess("✅ Kayıt başarılı! Şimdi mailine gelen kodu giriniz.");
          setShowVerificationPopup(true);
        }
      } else {
        if (data["$values"] && Array.isArray(data["$values"])) {
          let hasPasswordError = false;

          const tumHatalar = data["$values"]
            .map((err) => {
              if (err.code === "InvalidEmail" || err.description.includes("is invalid")) {
                return "❌ Geçerli bir e-posta adresi giriniz.";
              }

              if (err.code && err.code.startsWith("Password")) {
                hasPasswordError = true;
                return null;
              }

              return `❌ ${err.description}`;
            })
            .filter(Boolean);

          if (hasPasswordError) {
            tumHatalar.unshift("❌ Lütfen şifre kurallarını dikkate alınız.");
          }

          setError(tumHatalar.join("\n"));
        } else {
          setError(data.message || "❌ Kayıt başarısız!");
        }
      }

    } catch (err) {
      setError(err.message || "⚠️ Bağlantı hatası! Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="login-popup-overlay">
        <div className="login-popup-container"
        onClick={(e)=> e.stopPropagation()}
        >
          <button className="login-close-btn" onClick={onClose}>×</button>
          <h2 className="popup-title">Kayıt Ol</h2>

          <div className="input-box">
            <input
              type="text"
              name="adi"
              value={formData.adi}
              onChange={handleChange}
              required
              placeholder=" "
              id="adi"
            />
            <label htmlFor="adi">Ad</label>
          </div>

          <div className="input-box">
            <input
              type="text"
              name="soyadi"
              value={formData.soyadi}
              onChange={handleChange}
              required
              placeholder=" "
              id="soyadi"
            />
            <label htmlFor="soyadi">Soyad</label>
          </div>

          <div className="input-box">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder=" "
              id="email"
              readOnly={!!googleData?.email}
            />
            <label htmlFor="email">Email</label>
          </div>

          <div className="input-box">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder=" "
              id="password"
            />
            <label htmlFor="password">Password</label>
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="show-hide-toggle"
            >
              {showPassword ? "Gizle" : "Göster"}
            </span>
          </div>

          <div className="password-rules">
            <div className={passwordRules.minLength ? "rule passed" : "rule"}>
              {passwordRules.minLength ? "✔️" : "⭕"} En az 6 karakter
            </div>
            <div className={passwordRules.hasUpper ? "rule passed" : "rule"}>
              {passwordRules.hasUpper ? "✔️" : "⭕"} Büyük harf (A-Z)
            </div>
            <div className={passwordRules.hasLower ? "rule passed" : "rule"}>
              {passwordRules.hasLower ? "✔️" : "⭕"} Küçük harf (a-z)
            </div>
            <div className={passwordRules.hasNumber ? "rule passed" : "rule"}>
              {passwordRules.hasNumber ? "✔️" : "⭕"} Rakam (0-9)
            </div>
            <div className={passwordRules.hasSpecial ? "rule passed" : "rule"}>
              {passwordRules.hasSpecial ? "✔️" : "⭕"} Özel karakter (!@#...)
            </div>
          </div>

          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}

          <button className="login-submit" onClick={handleRegister} disabled={loading}>
            {loading ? "Kaydediliyor..." : "Kayıt Ol"}
          </button>

          <p className="signup-link">
            Zaten hesabınız var mı?{" "}
            <span onClick={onClose}>Giriş Yap</span>
          </p>
        </div>
      </div>

      {showVerificationPopup && (
        <EmailVerificationPopup
          email={formData.email}
          onClose={() => {
            setShowVerificationPopup(false);
            onClose();
          }}
          onSuccess={() => {
            setTimeout(() => {
              openLoginPopup(formData.email);
            }, 2500);
          }}
        />
      )}
    </>
  );
}
